import { combineReducers } from 'redux-immutable';
import {reducre as psTableReducer} from '../components/psTable/store';



const defaultCombine = combineReducers({
  psList:psTableReducer
})

export default defaultCombine